import { render, staticRenderFns } from "./ContentFilesEdit.vue?vue&type=template&id=4ce38a8a&scoped=true&"
import script from "./ContentFilesEdit.vue?vue&type=script&lang=js&"
export * from "./ContentFilesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce38a8a",
  null
  
)

export default component.exports